type PersonalStatuses =
  | 'NOT STARTED'
  | 'INCOMPLETE'
  | 'PENDING'
  | 'RESUBMIT'
  | 'COMPLETED'
type PersonalStatusKeys = 'N' | 'I' | 'P' | 'R' | 'C' | ''

const PersonalStatusesLockedKeys: [string, string] = ['P', 'C']
const PersonalStatusesLocked: [string, string] = ['PENDING', 'COMPLETED']

type ProfileData = {
  firstName?: string
  lastName?: string
  employeeEmailAddress?: string | null
}

type PersonalData = {
  essUserOnBoardingKey?: number
  firstName?: string
  middleInitial?: string
  lastName?: string
  employeeEmailAddress?: string | null
  ssn?: string | null
  ssnLastFour?: string | null
  addressLine1?: string | null
  addressLine2?: string | null
  stateValue?: string | null
  zip?: string | null
  city?: string | null
  dateOfBirth?: string | null
  genderValue?: string | null
  maritalStatusValue?: string | null
  mainPhoneNumber?: string | null
  secondaryPhoneNumber?: string | null
  emergencyContactName?: string | null
  emergencyPhoneNumber?: string | null
  emergencyRelationshipValue?: string | null
  alternateEmergencyContactName?: string | null
  alternateEmergencyPhoneNumber?: string | null
  alternateEmergencyRelationshipValue?: string | null
  statusDescription?: PersonalStatuses | null
  entityId: number
  corpEntityId: number
  storeEntityId: number
  isEmergencyContactMandatory: boolean
  axonifyUserID?: string | null
  employeeDiscount?: number | null
  essUserKey?: number
  hasCanary?: number
}

type updatedpersonalData = {
  entityId?: number
  essUserKey?: number
  firstName?: string
  middleInitial?: string | null
  lastName?: string | null
  addressLine1?: string | null
  addressLine2?: string | null
  city?: string | null
  stateValue?: string | null
  zip?: string | null
  dateOfBirth?: string | null
  genderValue?: string | null
  maritalStatusValue?: string | null
  mainPhoneNumber?: string | null
  secondaryPhoneNumber?: string | null
  emergencyContactName?: string | null
  emergencyPhoneNumber?: string | null
  emergencyRelationshipValue?: string | null
  alternateEmergencyContactName?: string | null
  alternateEmergencyPhoneNumber?: string | null
  alternateEmergencyRelationshipValue?: string | null
  employeeDiscount?: string | null
}

export {
  PersonalStatuses,
  PersonalStatusesLocked,
  PersonalData,
  ProfileData,
  PersonalStatusKeys,
  PersonalStatusesLockedKeys,
  updatedpersonalData
}
